import { ErrorAlert, SuccessAlert, InfoAlert } from "./alert.styles";

export const ALERT_TYPE = {
    error: 'error',
    success: 'success',
    info: 'info'
}
const getAlert = (alertType = ALERT_TYPE.success) => (
    {   [ALERT_TYPE.success]: SuccessAlert, 
        [ALERT_TYPE.error]: ErrorAlert, 
        [ALERT_TYPE.info]: InfoAlert, 
    }[alertType]
  )

const Alert = ({children, alertType, ...props}) => {
    const CMAlert = getAlert(alertType);
    return (
        <CMAlert {...props}>{children}</CMAlert>
    )
}

export default Alert;